import { i18n_t as $t } from '@/utils/i18n';

type ObjectPropertyMetadataInput = { DisplayName?: string | null; field?: string | null };

// Object properties are the only event-property family we let admins rename,
// so a rename can hide the underlying field identifier from downstream users.
// This helper pairs the display name with the field ("DisplayName (field)")
// via i18n so other locales can format the pair differently.
export function formatObjectPropertyLabel (metadata: ObjectPropertyMetadataInput): string {
    const field = metadata?.field ?? '';
    const displayName = typeof metadata?.DisplayName === 'string' ? metadata.DisplayName : '';
    if (!displayName || displayName === field) {
        return field;
    }

    return $t('objectAnalyticsLabels.{displayName} ({field})', { displayName, field });
}

// Chart-widget "View {property}" header link. Prefers the raw property label
// so a property with a customized display name reads "View Report ID"; falls
// back to the plural placeholder ("View Objects") when no label is present.
export function formatObjectPropertyHeaderLabel (
    property: { label?: string | null } | null | undefined,
    placeholders: { Plural: string; [key: string]: string },
): string {
    const rawLabel = (property?.label ?? '').trim();
    if (rawLabel) {
        return $t('objectAnalyticsLabels.View_objectPropertyLabel', { objectPropertyLabel: rawLabel });
    }

    return $t('objectAnalyticsLabels.View_Plural', placeholders);
}
